import { useState } from "react"
import { useEffect } from "react"
import { fetchSmeParticipants ,removeSmeParticipant} from "../../api/user"

const Participants = ({changeModalPopupDisplayData}) => {

    const [participants , setParticipants ] = useState(null)

    useEffect(() => {

     
      getParticipants()

    },[])

    const getParticipants = () => {

      let user_id = sessionStorage.getItem("user_id");

      if(user_id){

          let participants = fetchSmeParticipants({ sme_id : user_id})

          participants.then((val) => {

            if(val.data.response === "success") {

              setParticipants(val.data.data)

            }

            
          })
      }
    }

    const handleAddParticipant = () => {

        changeModalPopupDisplayData("sme_add_new_participant")
    }

    const removeParticipant = (id) => {

        let user_id = sessionStorage.getItem("user_id");
        let participants = removeSmeParticipant({ participiant_id : id , sme_id : user_id})

        participants.then(val => {
            if(val.data.response === "success") {
              alert("Successfully removed participant")
              getParticipants()

            }else{
              
              alert("Failed to removed participant")

            }
        })

    }

    return(

        <div className="popup_div_favorite edit_account_form p-5">
              <div className="update_profile_div">
                {/* <div className="edit_account float-right">
                  <a href="" className="edit_close"><img src="images/edit_arrow.svg" alt="" /></a>
                </div> */}
                <h3 className="text-center">All Participants</h3>
                <hr />
                <div className="promo_code_pop_inner update_profile_inner mt-4 custom_scroll">
                  

                  {

                      participants && participants.map(val => {

                        return(
                            <div className="participant_box p-4 mb-4" key={val.id}>
                              <div className="delet_boxBtn">
                                <a href="#" onClick={() => removeParticipant(val.participiant_id)}><img src="images/delete_icon.svg" alt="" className="img-fluid" /></a>
                              </div>
                              <div className="row">
                                <div className="col-sm-6 mb-3">
                                  <label>First Name</label>
                                  <input type="text" placeholder="First Name" value={val.user[0].first_name} name="first_name" className="form-control" readOnly={true}/> 
                                </div>
                                <div className="col-sm-6 mb-3">
                                  <label>Last Name</label>
                                  <input type="text" placeholder="Last Name" data-vv-as="last name" name="last_name" value={val.user[0].last_name}
                                    className="form-control" aria-required="true" aria-invalid="false" readOnly={true}/>
                                  <span className="is-danger" ></span>
                                </div>
                                <div className="col-sm-12">
                                  <label>Email</label>
                                  <input type="mail" placeholder="Last Name" data-vv-as="last name" name="last_name" value={val.user[0].email}
                                    className="form-control" aria-required="true" aria-invalid="false" readOnly={true}/>
                                  <span className="is-danger" ></span>
                                </div>
                              </div>
                            </div>
                        )
                      })
                  }
                  
                


                </div>
                <div className="form-group text-center pt-5"><button type="button" className="btn login_btn" onClick={handleAddParticipant}>Add Participants</button></div>
              </div>
            </div>
    )
}

export default Participants